<template>
    <Page header="Подписки" type="" :nopadding="false" header_pos="left">
        <template #body>
            <div class="w-full flex flex-column gap-3 overflow-hidden">
                <div v-if="!loading && subscriptions" class="w-full overflow-hidden" style="max-width:100%">
                    <PersonalSubscriptionList
                        ref="personalSubscriptionList"
                        :subscriptions="subscriptions"
                        :filters="lazyParams.filters"
                        :totalSubscriptions="totalSubscriptions"
                        :loading="loading"
                        :defaultParams="lazyParams"
                        @filter="setFilter"
                        @lazyParams="setParams"
                    />
                </div>
                <Skeleton v-else width="100%" height="30px" />
            </div>
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import PersonalSubscriptionList from '@/components/personal/subscription/list.vue'
import Page from '@/components/public/page.vue'
import { FilterMatchMode, FilterOperator } from '@primevue/core/api'

export default {
    data() {
        return {
            loading: false,
            subscriptions: null,
            lazyParams: {
                rows: 10,
                first: 0,
                sortField: null,
                sortOrder: null,
                sort: null,
                filters: {},
            },
            filters: {
                _id: { value: '', matchMode: 'contains' },
                ext_subscription_id: { value: '', matchMode: 'contains' },
                subscription_token: { value: '', matchMode: 'contains' },
                client_id: { value: '', matchMode: 'contains' },
                period_unit: { value: '', matchMode: 'contains' },
                status: { value: '', matchMode: 'contains' },
                bank_code: { value: '', matchMode: 'contains' },
                created_at: {
                    operator: FilterOperator.AND,
                    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
                },
            },
            totalSubscriptions: 0,
        }
    },
    components: {
        PersonalSubscriptionList,
        Page
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity, summary, detail, life: 3000 })
        },
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.loadSubscriptions()
        },
        setParams(params) {
            this.lazyParams = params
            this.loadSubscriptions()
        },
        async loadSubscriptions() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' })
            const subscriptions = await this.connect.GetPersonalSubscriptions(this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, {}).then(res => res)
            if (subscriptions.result) {
                this.subscriptions = subscriptions.data
                this.totalSubscriptions = subscriptions.total
            } else {
                this.subscriptions = []
                this.totalSubscriptions = 0
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке подписок')
            }
            this.loading = false
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.lazyParams.filters = this.filters

        const query = this.$route.query ? this.$route.query : {}
        if (query && query.id) this.filters.id = { value: query.id, matchMode: 'contains' }
        if (query && query.client_id) this.filters.client_id = { value: query.client_id, matchMode: 'contains' }

        this.loadSubscriptions()
    },
}
</script>